/**
 * Blog — the WLB blog feed (GetFeeds "Blogs"), rendered with the same post
 * stack as the profile and feed lists.
 */
import { useProfile } from '@wlb/shared/context/ProfileContext';
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import useBlogFeed from '@wlb/shared/hooks/useBlogFeed';
import { MorePage } from '../features/more/MorePage';
import { ProfilePostList } from '../features/profile/ProfilePostList';
import '../features/more/more.css';

export function Blog() {
  const { t } = useTranslation();
  const { profile } = useProfile();
  const blog = useBlogFeed();

  return (
    <MorePage title={t('blog.title')} subtitle={t('blog.subtitle')}>
      <ProfilePostList
        posts={blog}
        viewerProfile={profile}
        emptyMessage={t('blog.emptyTitle')}
      />
    </MorePage>
  );
}
